<div class="all-rea-page">
  <div class="all-rea-shell p-3 p-lg-4">
    <div class="d-flex flex-column flex-xl-row justify-content-between gap-3 align-items-xl-center">
      <div class="d-flex align-items-center gap-3">
        <span class="title-badge">
          <lucide-icon [img]="FileTextIcon" [size]="20"></lucide-icon>
        </span>
        <div>
          <h1 class="page-title-lite">All REA</h1>
          <p class="page-subtitle-lite mb-0">Monitor every REA region from one place and open the available regional workflows.</p>
        </div>
      </div>
    </div>

    <div class="row g-3 mt-1">
      @for (tile of summaryTiles(); track tile.label) {
        <div class="col-12 col-md-6 col-xl">
          <button
            type="button"
            class="summary-card h-100"
            [class.active]="selectedRea() === tile.label"
            (click)="selectSummaryTile(tile.label)"
          >
            <div class="summary-card-header">
              <div class="summary-label d-flex align-items-center gap-2">
                <lucide-icon [img]="tile.icon" [size]="16"></lucide-icon>
                <span>{{ tile.label }}</span>
              </div>
              <div class="summary-value">{{ tile.count }}</div>
            </div>

            <div class="summary-track">
              <div class="summary-segment" [ngClass]="{'empty': tile.count === 0}" style="width: 100%">{{ tile.count }}</div>
            </div>
          </button>
        </div>
      }
    </div>
  </div>

  <div class="panel-card p-3 p-lg-4">
    <div class="toolbar-row mb-3">
      <div class="search-field position-relative flex-grow-1">
        <lucide-icon [img]="SearchIcon" [size]="16" class="search-icon"></lucide-icon>
        <input
          class="form-control search-input"
          placeholder="Search region or Approval No."
          [value]="search()"
          (input)="onSearch(($any($event.target).value || '').toString())"
        />
      </div>

      <div class="toolbar-filters">
        <div class="filter-field">
          <!-- <label class="form-label mb-1">Month</label> -->
          <select class="form-select form-select-sm" [ngModel]="selectedRea()" (ngModelChange)="updateRea(($event || '').toString())">
            <option value="">ALL REA</option>
            @for (rea of reaOptions(); track rea) {
              <option [value]="rea">{{ rea }}</option>
            }
          </select>
        </div>
        <div class="filter-field">
          <!-- <label class="form-label mb-1">Month</label> -->
          <select class="form-select form-select-sm" [ngModel]="selectedMonth()" (ngModelChange)="updateMonth(($event || '').toString())">
            <option value="">All Months</option>
            @for (month of monthOptions(); track month) {
              <option [value]="month">{{ monthLabel(month) }}</option>
            }
          </select>
        </div>

        <div class="filter-field">
          <!-- <label class="form-label mb-1">Year</label> -->
          <select class="form-select form-select-sm" [ngModel]="selectedYear()" (ngModelChange)="updateYear(($event || '').toString())">
            <option value="">ALL Years</option>
            @for (year of yearOptions(); track year) {
              <option [value]="year">{{ year }}</option>
            }
          </select>
        </div>

        <button type="button" class="refresh-btn" (click)="refreshFilterData()">
          <lucide-icon [img]="RefreshCcwIcon" [size]="16"></lucide-icon>
          <span>Refresh</span>
        </button>
      </div>
    </div>

    <div class="table-wrap">
      <div class="table-responsive" style="max-height: 500px; overflow-y: auto;">
        <table class="table mb-0 align-middle">
          <thead class="table-head sticky-top">
            <tr>
              <th class="">S.No.</th>
              <th class="col-access">ACCESS</th>
              <th class="col-trader">TRADER</th>
              <th class="col-entity">FROM (Embedded Entity)</th>
              <th class="col-entity">TO (Embedded Entity)</th>
              <th class="col-app">APPROVAL NO</th>
              <th class="col-path">PATH</th>
              <th class="col-boundary">Actual Quantum</th>
            </tr>
          </thead>
          <tbody>
            @if (loading()) {
              <tr>
                <td colspan="7" class="text-center py-5 text-muted">Loading REA data...</td>
              </tr>
            } @else if (tableRows().length === 0) {
              <tr>
                <td colspan="7" class="text-center py-5 text-muted">Whoops! No Data Found</td>
              </tr>
            }

            @for (row of tableRows(); track row.app_no + '-' + row.rpc_region + '-' + row.report_id; let i = $index) {
              <tr>
                <td>{{ (page() - 1) * pageSize() + i + 1 }}</td> 
                <td>
                  @if (row.access_route) {
                    <a class="access-link" [routerLink]="row.access_route">{{ row.access_label }}</a>
                  } @else {
                    <span class="access-link disabled">{{ row.access_label }}</span>
                  }
                </td>
                <td>
                  <span class="trader-chip">{{ row.trader || row.rpc_region }}</span>
                </td>
                <td>{{ row.from_entity || '-' }}</td>
                <td>{{ row.to_entity || '-' }}</td>
                <td>{{ row.app_no || '-' }}</td>
                <td>{{ row.path || '-' }}</td>
                <td class="boundary-cell">
                  {{ row.actual_quantum !== null && row.actual_quantum !== undefined
                    ? (row.actual_quantum | number:'1.0-5')
                    : '-' }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>

    <div class="pager-row mt-3">
      <div class="pager-meta">{{ startRow() }}-{{ endRow() }} of {{ totalRows() }} rows</div>
      <div class="pagination-shell">
        <button class="pager-btn" [disabled]="page() <= 1 || loading()" (click)="goToPage(1)" aria-label="First page">
          <lucide-icon [img]="ChevronsLeftIcon" [size]="14"></lucide-icon>
        </button>
        <button class="pager-btn" [disabled]="page() <= 1 || loading()" (click)="goToPage(page() - 1)" aria-label="Previous page">
          <lucide-icon [img]="ChevronLeftIcon" [size]="14"></lucide-icon>
        </button>
        <span class="page-indicator current">{{ page() }}</span>
        <button class="pager-btn" [disabled]="page() >= totalPages() || loading()" (click)="goToPage(page() + 1)" aria-label="Next page">
          <lucide-icon [img]="ChevronRightIcon" [size]="14"></lucide-icon>
        </button>
        <button class="pager-btn" [disabled]="page() >= totalPages() || loading()" (click)="goToPage(totalPages())" aria-label="Last page">
          <lucide-icon [img]="ChevronsRightIcon" [size]="14"></lucide-icon>
        </button>
        <select class="form-select form-select-sm page-size-select pager-size-select" [value]="pageSize()" (change)="onPageSizeChange(($any($event.target).value || '10').toString())" aria-label="Rows per page">
          @for (size of pageSizes; track size) {
            <option [value]="size">{{ size }}/Page</option>
          }
        </select>
      </div>
    </div>
  </div>
</div>
